import { createSlice } from "@reduxjs/toolkit";
import { manufacturerAction } from "../actions/manufacturers.action";

const initialState = {
  manufacturers: [],
};

const manufacturers = createSlice({
  name: "manufacturers",
  initialState,
  reducers: manufacturerAction,
});

export const { setManufacturers } = manufacturers.actions;
export default manufacturers.reducer;
